// (() => {
  
//   const root = document.getElementById('wc-root');
//   const datas = JSON.parse(root.dataset.datas);
//   const groups = JSON.parse(root.dataset.groups);
//   const options = JSON.parse(root.dataset.options);
//   console.log(datas)
//   console.log(groups)
//   console.log(options)
//   const basePrice = Number(root.dataset.basePrice);
//   const variantId = root.dataset.variantId;

//   const canvas = document.getElementById('wc-canvas');
//   const ctx = canvas.getContext('2d');
//   // const toolbar = document.querySelector('.wc-toolbar');
//   // const summary = document.querySelector('.wc-summary .wc-total-num');
//   // const addBtn = document.getElementById('wc-addcart');

//     const watch = createWatch({
//       canvas: '#wc-canvas',          // 画布选择器或 DOM
//       stack: {                   // 所有可叠组件，壳也在这里
//         case: [],   // 支持多素材循环
//         dial: [],
//         hour: '',
//         min:  '',
//         sec:  '',
//         strapTop: '',
//         strapBottom: '',
//       },
//       pos: {                     // 各图层中心（可选，默认画布中心）
//         case: {x:200, y:200},
//         dial: {x:200, y:200},
//         hour: {x:200, y:200},
//         min:  {x:200, y:200},
//         sec:  {x:200, y:200}
//       }
//     });
//   /* 一级枚举写死 表壳、表盘、时分针、秒针、GMT、表单、内影、圈口、机芯、定制 */
//   const L1_MAP = {
//     case:{ name: '表壳',   key: 'case' },
//     dial:{ name: '表盘',   key: 'dial' },
//     hands:{ name: '时分针', key: 'hands' },
//     secondHand:{ name: '秒针',   key: 'secondHand' },
//     gmtHand:{ name: 'GMT',    key: 'gmtHand' },
//     glass:{ name: '表带',   key: 'glass' },
//     innerRing: { name: '内影',   key: 'innerRing' },
//     bezel:{ name: '圈口',   key: 'bezel' },
//     movement:{ name: '机芯',   key: 'movement' },
//     custom:{ name: '定制',   key: 'custom' }
//   };
//   const sentData = {}
//   let selected = {};          // {case:{id,price,img}, dial:{}, strap:{}}
//   let activeL1 = 'case';      // 默认一级 38122fbf1d6e4db47fb65f9afbd08a24

//   /* 图片地址获取 */
//   const STORE   = 'lightofmile.com';   // 你的二级域名
//   const TOKEN   = 'a6c1e3e4a48ae0e8326d1de55b1ee408'; // Storefront 公开 token
//   const API_VER = '2025-10';

//   /******** 2. gid → url 的通用函数 ********/
//   async function gidToURL(gid) {
//     const res = await fetch(`https://${STORE}/api/${API_VER}/graphql.json`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'X-Storefront-Access-Token': TOKEN
//       },
//       body: JSON.stringify({
//         query: `query($id:ID!){
//           node(id:$id){
//             ... on MediaImage{
//               image{ url(transform:{maxWidth:800}) }
//             }
//           }
//         }`,
//         variables: { id: gid }
//       })
//     });
//     const { data, errors } = await res.json();
//     if (errors) throw errors;
//     return data.node.image.url;
//   }

//   /* ========== 2. 公共函数 ========== */
// async function getMetaobject(gid) {
//   const res = await fetch(`https://${STORE}/api/${API_VER}/graphql.json`, {
//     method : 'POST',
//     headers: {
//       'Content-Type' : 'application/json',
//       'X-Shopify-Storefront-Access-Token': TOKEN
//     },
//     body: JSON.stringify({
//         query: `
//           query($id:ID!){
//             metaobject(id:$id){
//               id
//               type
//               handle
//               fields{ key value }
//             }
//           }`,
//         variables: { id: gid }
//       })
//     }).then(r => r.json());

//   if (res.errors) throw res.errors;
//   return res.data.node || res.data.metaobject;   // 没找到就是 null
// }
// datas.sort((a, b) => a.oder - b.oder);
// /* 渲染left 标题 */
// (async () => {
//   // 1. 先把一级数据拿回来（你已经有了）
//   // const datas = ...;

//   // 2. 并行拉取 parent_type
//   const htmlArr = await Promise.all(
//     datas.map(async item => {
//       let pid = '';
//       if (item.groups?.[0]) {
//         const meta = await getMetaobject(item.groups[0]);   // 现在可以 await 了
//         pid = meta.fields.find(f => f.key === 'parent_type')?.value || '';
//       }
//        if (pid) {
//         sentData[pid] = {type:'', text: '', vantId: '', price: '' };
//       }
//       return `
//         <div class="title_content">
//           <div class="title_header">${item.group_name}</div>
//           <div class="title_value" id="${pid}"></div>
//         </div>`;
//     })
//   );

//   // 3. 一次性插入
//   document.getElementById('left-content').innerHTML = htmlArr.join('');
// })();
// console.log(sentData,"123")
//   /* 循环渲染一级 */
//   const contents = document.createElement('div');
//   const level2 = document.createElement('div');
//   const level3 = document.createElement('div');
//   async function renderList() {
//   const box = document.getElementById('wc-root');
   
//    contents.className = 'contents-item';
//    level2.className = 'level2-item';
//    level3.className = 'level3-item';
//    box.appendChild(contents);
//    box.appendChild(level2);
//    box.appendChild(level3);
//   for (const item of datas) {
    
//     const wrap = document.createElement('div');
//     wrap.className = 'group-item';
//     if (item.group_image) {
//       // 有图片：先拿地址，再插 <img>
//       try {
//         const url = await gidToURL(item.group_image);
//         const img = document.createElement('img');
//         img.src = url;
//         img.alt = item.group_name;
//         wrap.appendChild(img);
//       } catch (e) {
//         // 兜底：如果查图失败，就回退成文字
//         wrap.textContent = item.group_name;
//       }
//     } else {
//       // 没图片：直接文字
//       wrap.textContent = item.group_name;
//     }
//     if (item.groups?.length) {
//       wrap.dataset.groups = JSON.stringify(item.groups);   // 整组存
//       // wrap.dataset.parentGid = item.id;               // 如果还要挂别的
//     }

//     contents.appendChild(wrap);
//     if(item.groups && item.groups.length > 0 && item.oder === 1) {
//       const html = await buildColorHtml(item);
//       document.querySelector('.level2-item').innerHTML = html;
//     }
   
//   }
  
// }
// renderList()

// // 先把所有需要异步转 URL 的 gid 收集起来，一次性并发请求，避免重复调用
// async function gidsToUrlMap(gids) {
//   const uniq = [...new Set(gids)];                 // 去重
//   const jobs  = uniq.map(g => gidToURL(g).then(url => [g, url]));
//   const pairs = await Promise.all(jobs);
//   return Object.fromEntries(pairs);                // { gid : url , ... }
// }
// // 主逻辑
// async function buildColorHtml(item) {
//    if (!item.groups?.length) return '';

// /* ---------- 1. 拉第二级原始 fields ---------- */
// const level2List = await Promise.all(
//   item.groups.map(k => getMetaobject(k).then(r => r.fields || []))
// );

// /* ---------- 2. 拆成“带 expand”和“不带 expand” ---------- */
// const withExpand = [];          // 需要拉第三级的
// const withoutExpand = [];       // 兜底渲染
// level2List.forEach(fields => {
//   const obj = Object.fromEntries(fields.map(({key, value}) => [key, value]));
//   if (obj.expand_color) {
//     withExpand.push({
//       parent_type: obj.parent_type || '',   // 第二级的 parent_type
//       expand_color: obj.expand_color
//     });
//   } else {
//     withoutExpand.push(obj);                // 给兜底用
//   }
// });

// /* ---------- 3. 拉第三级 + 拼 HTML ---------- */
// let colorHtml = '';
// if (withExpand.length) {
//   // 3-1 收集所有第三级 gid
//   const allExpandGids = withExpand.flatMap(o => JSON.parse(o.expand_color));

//   // 3-2 拉第三级元对象
//   const expandObjs = await Promise.all(
//     allExpandGids.map(async gid => {
//       const {fields = []} = await getMetaobject(gid);
//       return Object.fromEntries(fields.map(({key, value}) => [key, value]));
//     })
//   );

//   // 3-3 换图片 URL
//   const imageGids = expandObjs.flatMap(o => [o.color_image, o.color_show_image]);
//   const urlMap = await gidsToUrlMap(imageGids);

//   /* ---- 自动画第一张 ---- */
//   const firstShowGid = expandObjs[0]?.color_show_image;
//   const firstUrl = urlMap[firstShowGid];
//   if (firstUrl) {
//     // const canvas = document.getElementById('wc-canvas');
//     // const ctx = canvas?.getContext('2d');
//     // if (ctx) {
//     //   const img = new Image();
//     //   img.crossOrigin = 'anonymous';
//     //   img.onload = () => {
//     //     ctx.clearRect(0, 0, canvas.width, canvas.height);
//     //     ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
//     //   };
//     //   img.src = firstUrl;
//     // }
//      watch.urls.case = [firstUrl];   // 覆盖旧数组
//      watch.index.case = 0;             // 重置下标
//      watch.remove('case');             // 先清掉旧图层
//      await watch.add('case');          // 加载新图
//   }

//   /* ---- 拼第三级 HTML ---- */
//   // 先给每个第三级找到它对应的第二级 parent_type
//   let idx = 0;
//   colorHtml = withExpand.map(l2 => {
//     const gids = JSON.parse(l2.expand_color);
//     return gids.map(() => {
//       const o = expandObjs[idx++];          // 顺序一致
//       console.log(o,"000000")
//       return `
// <div class="color_content">
//   <div class="color_title" title="${o.color_name}">${o.color_name}</div>
//   <div class="color_value"
//        data-attribute-name="${o.attribute_name}"
//        data-color_price ='${JSON.stringify(o.color_price) || ''}'
//        data-variant_id='${o.variant_id || ''}'
//        data-image-url="${urlMap[o.color_show_image] || ''}"
//        data-title-id="${l2.parent_type}">   <!-- 第二级的 parent_type -->
//     <img src="${urlMap[o.color_image] || ''}" width="50" height="50"/>
//   </div>
// </div>`;
//     }).join('');
//   }).join('');
// }

// /* ---------- 4. 兜底渲染（自己写） ---------- */
// const fallbackHtml = await renderFallback(withoutExpand);

// /* ---------- 5. 返回 ---------- */
// return colorHtml + fallbackHtml;
// }

// // 占位：你想怎么渲染「没有 expand_color」的对象就写这里
// async function renderFallback(objs) {
//   console.log(objs)
//   if (!objs.length) return '';
//   // 示例：直接输出文字
//   return objs.map(o => `
// <div class="fallback_content">
//   <span>${o.title || o.name || '暂无标题'}</span>
// </div>`).join('');
// }

// // 给所有 .color_value 绑定一次事件（事件委托，防止后续动态插入）
// document.addEventListener('click',async function  (e) {
//   const box = e.target.closest('.color_value');   // 点 img 也算点到盒子
//   if (!box) return;
//   console.log(box.dataset,"box")
//   const titleId  = box.dataset.titleId;
//   const attrName = box.dataset.attributeName;
//   const price_delta = box.dataset.color_price;
//   const variant_id = box.dataset.variant_id || '';
//   const imgUrl = box.dataset.imageUrl;
//   if (titleId) {
//     const target = document.getElementById(titleId);
//     if (target) target.textContent = attrName;
//      console.log(price_delta,'xuanrang1')
//     sentData[titleId].type = titleId;
//     sentData[titleId].text = attrName;
//     sentData[titleId].price =  price_delta.amount ? price_delta.amount * 100 : 0; 
//     sentData[titleId].vantId = box.dataset.variant_id || null;
//   }
//   /* 更新金额 */
//   updatePrice(sentData)
//   if (!imgUrl) return;
//      watch.urls.case = [imgUrl];   // 覆盖旧数组
//      watch.index.case = 0;             // 重置下标
//      watch.remove('case');             // 先清掉旧图层
//      await watch.add('case');
// });

// /* 公共函数 获取元子段gid 返回扁平化数据 */
// async function flatteningevent(gids) {
//   console.log(gids,'gids')
//   const metaList = [];

//   for (const gid of gids) {
//     try {
//       const meta = await getMetaobject(gid);
//       metaList.push(meta);
//     } catch (err) {
//       console.warn('getMetaobject 失败：', gid, err);
//     }
//   }

//   return flatList = metaList.map(m =>
//     m.fields.reduce((o, { key, value }) => {
//       try { o[key] = JSON.parse(value); } catch { o[key] = value; }
//       return o;
//     }, { id: m.id, type: m.type, handle: m.handle })
//   );
  
// }

// // 事件委托，挂在已经存在的父级上（contents 节点）
// contents.addEventListener('click', async (e) => {
//   const item = e.target.closest('.group-item');
//   if (!item) return;          // 点空白直接忽略

//   const raw = item.dataset.groups;
//   if (!raw) return;           // 没有 groups 也忽略

//   const gids = JSON.parse(raw);   // 一定是数组
//   const level2Datas = await flatteningevent(gids)
//   if(!level2Datas[0].expand_color){
//     const level3Datas = await flatteningevent(level2Datas[0]?.group)
//     console.log(level2Datas,'level2Datas')
//     //渲染第二级
//     level2.innerHTML = '';          // 清空
//     level2.appendChild(buildlevel2(level2Datas));   // 插入新列表
//     console.log(await buildlevel3(level3Datas),'buildlevel3(level3Datas)')
//     level3.innerHTML = '';          // 清空
//     level3.appendChild(await buildlevel3(level3Datas));
//   }else {
//     console.log(level2Datas[0])
//     const html = await buildColorHtml(datas[0]);
//       level2.innerHTML = '';
//       level3.innerHTML = ''; 
//       level2.innerHTML = html;
    
//   }
  
// });

// /* 公共函数 切换渲染第二级并且渲染第二级 */

// function buildlevel2(dataArry= []) {
//   if (!Array.isArray(dataArry) || dataArry.length === 0) return '';

//   const frag = document.createDocumentFragment();

//   dataArry.forEach(item => {
//     // 把 group 数组转回 JSON 字符串，方便塞到 data-groups
//     const groupJson = JSON.stringify(item.group || []);

//     const div = document.createElement('div');
//     div.className = 'level2-item-content';
//     div.dataset.groups = groupJson;          // 注意这里必须是字符串
//     div.textContent = item.group_name || ''; // 显示文字
//     frag.appendChild(div);
//   });

//   return frag;   // 返回片段，不直接操作 DOM，方便外面统一插入

// }

// /* 公共函数 切换渲染第三级 */

// async function buildlevel3(dataArray= []) {
//  if (!Array.isArray(dataArray) || dataArray.length === 0) {
//     const empty = document.createElement('div');
//     empty.className = 'level3-empty';
//     empty.textContent = '暂无子分组';
//     return empty;
//   }

//   const frag = document.createDocumentFragment();

//   /* 用 for…of 保证顺序，且可以 await */
//   for (const item of dataArray) {
//     const div = document.createElement('div');
//     div.className = 'level3-item-content';

//     /* 1. 图片 */
//     if (item.preview_img) {
//       try {
//         const url = await gidToURL(item.preview_img);
//         const img = document.createElement('img');
//         img.src = url;
//         img.alt = item.group_name || '';
//         div.appendChild(img);
//       } catch (e) {
//         console.warn('preview_img 加载失败', e);
//       }
//     }

//     /* 2. 文字标题 */
//     // const txt = document.createElement('span');
//     // txt.textContent = item.group_name || '未命名';
//     // div.appendChild(txt);

//     /* 3. 把后续可能用到的数据挂到 dataset */
//     div.dataset.groups   = JSON.stringify(item.group || []);
//     div.dataset.option_name = item.option_name || '';
//     div.dataset.price_delta = JSON.stringify(item.price_delta || {});
//     div.dataset.parent_type = item.parent_type || '';
//     div.dataset.variant_id = item.variant_id || ''
//     /* 4. 如果有预览图字段，也异步拿一下 */
//     if (item?.preview_show_img) {
//       try {
//         div.dataset.preview_show_img = await gidToURL(item.preview_show_img);
//       } catch (e) {
//         div.dataset.preview_show_img = '';
//       }
//     }

//     frag.appendChild(div);
//   }

//   return frag;   // 全部图片都到位后再返回

// }
// level3.addEventListener('click',async (e) => {
//   const item = e.target.closest('.level3-item-content');
//   if (!item) return;
//   console.log(item.dataset,'item.dataset')
//   const newDialUrl = item.dataset.preview_show_img;
//   if (!newDialUrl) return;
//   console.log('点击捕获到，target:',item.dataset, newDialUrl);

//   if(item.dataset.parent_type && item.dataset.parent_type.startsWith('glass')){
//      await watch.add('strapTop',    {url: newDialUrl});
//      await watch.add('strapBottom', {url: newDialUrl});
//     watch.setImage('strapTop', newDialUrl);
//     watch.setImage('strapBottom', newDialUrl); 
//     renderTypeText(item) 
//   }else{
//     console.log("zhixing")
//       await watch.add(item.dataset.parent_type,    {url: newDialUrl});
//       watch.setImage(item.dataset.parent_type, newDialUrl); 
//       renderTypeText(item) 
//   }
  
    
// });
// // 第一次渲染：你想先叠哪张就调哪张
// // watch.add('case');   // 先上壳
// // watch.add('dial');   // 再上表盘
// // watch.add('hour');
// // watch.add('min');

// // // 之后随时：
// // watch.change('case'); // 壳循环到下一张
// // watch.remove('case'); // 拿掉壳
// // watch.change('dial'); // 换表盘

// /**
//  * createWatch
//  * @param {String|HTMLCanvasElement} opt.canvas 画布
//  * @param {Object} opt.stack  {key: url|url[]}
//  * @param {Object} [opt.pos]  各图层中心，缺省画布中心
//  * @return {Object} {add,remove,change,canvas}
//  */
// const LAYOUT = {
//   case:   { x: 0,   y: 0,   scale: 0.5,    z: 0 }, // 表壳最大
//   strapTop:   { x: 1.2, y: 518, scale: 0.13,   z: -1, anchor: 'top' },    // 12 点
//   strapBottom:{ x: 1, y: -330, scale: 0.13,   z: -1, anchor: 'bottom' }, // 6 点
//   dial:   { x: 1.2,   y: 0,   scale: 0.40, z: 1 }, // 表盘缩 0.88 放壳里
//   hour:   { x: 0,   y: 0,   scale: 0.18,    z: 2 }, // 时针
//   minute: { x: 0,   y: 0,   scale: 1,    z: 3 }, // 分针
//   second: { x: 0,   y: 0,   scale: 1,    z: 4 }, // 秒针
// };
// function createWatch(opt) {
//   const canvas = typeof opt.canvas === 'string'
//                ? document.querySelector(opt.canvas)
//                : opt.canvas;
//   const ctx    = canvas.getContext('2d');
//   const size   = {w: canvas.width, h: canvas.height};
//   const center = {x: size.w/2, y: size.h/2};

//   const layers = {};   // 当前已叠的图：{key: HTMLImageElement|null}
//   const index  = {};   // 多素材循环指针：{key: Number}
//   const urls   = {};   // 原始地址或数组：{key: String|String[]}
//   const pos    = {};   // 各图层中心

//   /* 初始化 pos & urls */
//   Object.keys(opt.stack).forEach(k => {
//     urls[k] = Array.isArray(opt.stack[k]) ? opt.stack[k] : [opt.stack[k]];
//     index[k] = 0;
//     pos[k]   = opt.pos?.[k] || center;
//   });

//   /* 工具：加载单张图 */
//   function load(url) {
//     return new Promise((res, rej) => {
//       const img = new Image();
//       img.crossOrigin = 'anonymous';
//       img.onload  = () => res(img);
//       img.onerror = rej;
//       img.src = url;
//     });
//   }

//   /* 重绘：按 key 顺序依次叠图 */
//   function redraw() {
//   ctx.clearRect(0, 0, size.w, size.h);
//   // 按 z 从小到大画
//   Object.keys(LAYOUT)
//     .sort((a, b) => LAYOUT[a].z - LAYOUT[b].z)
//     .forEach(k => {
//       const img = layers[k];
//       if (!img) return;          // 这层还没图就跳过

//       const {x, y, scale,anchor} = LAYOUT[k];
//       const dw = img.width  * scale;
//       const dh = img.height * scale;

//       // 计算实际左上角坐标
//       let dx = center.x + x;
//       let dy = center.y + y;

//       if (anchor === 'top')    dy = 0           + y - dh;   // 顶边向下偏移
//       if (anchor === 'bottom') dy = size.h - dh + y;        // 底边向上偏移

//       // 默认居中
//       dx -= dw / 2;
//       dy -= dh / 2;
//       ctx.drawImage(img, dx, dy, dw, dh);
//     });
// }


//   /* API */
//   return {
//     canvas,
//     async add(keyOrOpts, opts = {}) {
//       console.log(keyOrOpts,opts)
//       const isLegacy = typeof keyOrOpts === 'string';
//       const key  = isLegacy ? keyOrOpts : keyOrOpts;
//       const url  = isLegacy ? urls[key][index[key]] : opts.url;
//       const draw = opts.draw || null;

//       if (!url || url === 'undefined' || url.trim() === '') return;
//       if (layers[key]) return;

//       const img = await load(url);
      
//       // 关键：等图片回来再存
//       layers[key] = draw ? { img, draw } : img;  // 兼容旧结构
//       console.log('[add] 刚刚写入的 layers['+key+'] =', layers[key]);
//       redraw();
//     },
//     remove(key) {
//       if (!layers[key]) return;
//       layers[key] = null;
//       delete layers[key];
//       redraw();
//     },
//     async change(key) {                 // 循环换素材
//       const arr = urls[key];
//       index[key] = (index[key] + 1) % arr.length;
//       const url = arr[index[key]];
//       layers[key] = await load(url);
//       redraw();
//     },
//     async setImage(key, url) {
//     layers[key] = await load(url);
//     redraw();
//   },
//     urls,      // ← 新增
//     index,     // ← 新增

//   };
// }

// /* 渲染型号 */
// function renderTypeText(item){
  
//   if(!item) return
//   const titleId  = item.dataset.parent_type;
//   const attrName = item.dataset.option_name;
//   const price_delta = JSON.parse(item.dataset.price_delta)
//   if (titleId) {
//     const target = document.getElementById(titleId);
//     if (target) target.textContent = attrName;
//   }
//   if(sentData[titleId]){
//     console.log(price_delta,'xuanrang1')
//     sentData[titleId].type = titleId;
//     sentData[titleId].text = attrName;
//     sentData[titleId].price =  price_delta.amount ? price_delta.amount * 100 : 0; 
//     sentData[titleId].vantId = item.dataset.variant_id || null;
//   }
//   /* 更新金额 */
//   updatePrice(sentData)
//   console.log(sentData,'xuanrang')
// }
// function updatePrice(obj) {
//     const newPrice = sumPriceToYuan(obj)
//     document.getElementById('totalPrice').textContent = newPrice;
// }
// /**
//  * 把任意对象里所有 price 字段求和，分→元
//  * @param {Object} data 你的 JSON
//  * @returns {Number}  单位“元”，保留 2 位小数
//  */
// function sumPriceToYuan(data) {
//   let total = 0;

//   // 递归扫描
//   function walk(obj) {
//     if (Array.isArray(obj)) {
//       obj.forEach(walk);
//     } else if (obj !== null && typeof obj === 'object') {
//       Object.keys(obj).forEach(k => {
//         if (k === 'price') {
//           const v = obj[k];
//           // 空串、null、undefined 都算 0
//           total += Number(v) || 0;
//         } else {
//           walk(obj[k]);
//         }
//       });
//     }
//   }

//   walk(data);
//   return (total / 100).toFixed(2); // 字符串，如 "126.00"
// }





 

  

//   /* 加入购物车 */
//   function addToCart() {
//     for (const key in sentData) {
//       const v = sentData[key].vantId;
//       if (v === null || v === '') {
//         alert('Please choose to customize all');   // 换成你自己的 UI 提示
//         return;               // 中断后续逻辑
//       }
//     }
//     const items = Object.values(sentData).map(item => ({
//       id: Number(item.vantId),   
//       quantity: 1,               
//       properties:{[item.type]: item.text} 
//     }));
//     console.log(items);
//     fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(items)
//     })
//     .then(r => r.json())
//     .then(data => {
//       refreshMiniCart();
//     })
//     .catch(err => alert(err.message));
//   }
//   async function refreshMiniCart() {
//     const res = await fetch('/cart.js');
//     const cart = await res.json();
//     document.querySelector('.cart-count').textContent = cart.item_count;
//   }
//    window.addToCart = addToCart;
// })();
(() => {
  /***************** 基本配置 *****************/
  const root = document.getElementById('wc-root');
  let datas = JSON.parse(root.dataset.datas || '[]');
  const groups = JSON.parse(root.dataset.groups || '[]');
  const options = JSON.parse(root.dataset.options || '[]');
  const basePrice = Number(root.dataset.basePrice);
  const variantId = root.dataset.variantId;
  // 主商品变体 ID：优先用主题配置 main_variant_id，没配则退回当前产品的 selected_or_first_available_variant.id
  const mainVariantId = (root.dataset.mainVariantId || '').trim() || variantId;

  // 最大类目可配置：若主题中填写了一级类目顺序，则按该顺序过滤并排序
  const firstLevelOrderStr = (root.dataset.firstLevelOrder || '').trim();
  if (firstLevelOrderStr) {
    const orderHandles = firstLevelOrderStr.split(',').map((h) => h.trim()).filter(Boolean);
    const ordered = [];
    for (const h of orderHandles) {
      const found = datas.find((d) => (d.handle || '').trim() === h);
      if (found) ordered.push(found);
    }
    if (ordered.length) datas = ordered;
  }

  // 可选部件：主题中配置的 parent_type 不参与必选校验，未选不提交（留空时默认 sec,second）
  const optionalPartTypesStr = (root.dataset.optionalPartTypes || '').trim();
  const OPTIONAL_PART_KEYS = optionalPartTypesStr
    ? optionalPartTypesStr.split(',').map((s) => s.trim()).filter(Boolean)
    : ['sec', 'second'];

  // 使用三级类目的类目：这些一级的 parent_type 强制走「二级列表+三级选项」（留空则按 expand_color 自动判断）
  const threeLevelStr = (root.dataset.threeLevelParentTypes || '').trim();
  const threeLevelParentTypesSet = new Set(
    threeLevelStr ? threeLevelStr.split(',').map((s) => s.trim()).filter(Boolean) : []
  );

  // 把变体 ID 规范化为 Shopify /cart/add.js 接受的形式：纯数字字符串转换为 Number，其它原样返回
  function normalizeVariantId(id) {
    if (id == null) return null;
    const v = String(id).trim();
    if (!v) return null;
    // 纯数字：用数字 ID（/cart/add.js 期望的是变体数字 ID）
    if (/^\d+$/.test(v)) return Number(v);
    // 如果你后续改为传 gid（不推荐给 /cart/add.js），这里会原样返回
    return v;
  }

  const canvas = document.getElementById('wc-canvas');
  const ctx = canvas.getContext('2d');

  const sentData = {};   // 记录当前各项选择 { [parent_type]: { type, text, price, vantId } }
  let selected = {};
  let activeL1 = 'case';

  /***************** 简单的 Loading 状态控制 *****************/
  function setLoading(on) {
    const root = document.getElementById('wc-root');
    if (!root) return;
    if (on) {
      root.classList.add('loading');
      canvas.classList.add('loading');
    } else {
      root.classList.remove('loading');
      canvas.classList.remove('loading');
    }
  }

  /***************** Shopify Storefront API 基本信息 *****************/
  const STORE   = 'lightofmile.com';   // 你的店铺域名
  const TOKEN   = 'a6c1e3e4a48ae0e8326d1de55b1ee408'; // Storefront 公共 token

  // 建议使用当前已存在的版本，例如 2024-10，避免未来版本不存在导致报错
  const API_VER = '2024-10';

  // 统一的请求头
  const SF_HEADERS = {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': TOKEN,
  };

  /***************** 手表画布引擎：布局配置 *****************/
  const LAYOUT = {
    case:        { x: 0,   y: 0,    scale: 0.5,  z: 0 },  // 表壳
    strapTop:    { x: 1.2, y: 518,  scale: 0.13, z: -1, anchor: 'top' },    // 表带上
    strapBottom: { x: 1,   y: -330, scale: 0.13, z: -1, anchor: 'bottom' }, // 表带下
    dial:        { x: 1.2, y: 0,    scale: 0.40, z: 1 },  // 表盘
    hour:        { x: 0,   y: 0,    scale: 0.18, z: 2 },  // 时针
    minute:      { x: 0,   y: 0,    scale: 1,    z: 3 },  // 分针
    second:      { x: 0,   y: 0,    scale: 1,    z: 4 },  // 秒针
  };

  /***************** 手表渲染引擎：createWatch *****************/
  /**
   * createWatch
   * @param {String|HTMLCanvasElement} opt.canvas 画布
   * @param {Object} opt.stack  {key: url|url[]}
   * @param {Object} [opt.pos]  各图层中心，缺省画布中心
   * @return {Object} {add,remove,change,setImage,canvas,urls,index}
   */
  function createWatch(opt) {
    const canvas = typeof opt.canvas === 'string'
                 ? document.querySelector(opt.canvas)
                 : opt.canvas;
    const ctx    = canvas.getContext('2d');
    const size   = {w: canvas.width, h: canvas.height};
    const center = {x: size.w/2, y: size.h/2};

    const layers = {};   // 当前叠放的图层：{ key: HTMLImageElement | null }
    const index  = {};   // 各图层当前索引（多素材轮播）
    const urls   = {};   // 各图层素材 URL 列表：{ key: String[] }
    const pos    = {};   // 各图层中心位置（暂时未用）

    Object.keys(opt.stack).forEach(k => {
      urls[k]  = Array.isArray(opt.stack[k]) ? opt.stack[k] : [opt.stack[k]];
      index[k] = 0;
      pos[k]   = opt.pos?.[k] || center;
    });

    // 加载单张图片
    function load(url) {
      return new Promise((res, rej) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload  = () => res(img);
        img.onerror = rej;
        img.src = url;
      });
    }

    // 重绘：按 z 顺序叠图
    function redraw() {
      ctx.clearRect(0, 0, size.w, size.h);

      Object.keys(LAYOUT)
        .sort((a, b) => LAYOUT[a].z - LAYOUT[b].z)
        .forEach(k => {
          const layer = layers[k];
          if (!layer) return;

          // layer 可能是 img 或 { img, draw }，目前我们只用 img
          const img = layer.img || layer;
          if (!img) return;

          const {x, y, scale, anchor} = LAYOUT[k];
          const dw = img.width  * scale;
          const dh = img.height * scale;

          let dx = center.x + x;
          let dy = center.y + y;

          if (anchor === 'top')    dy = 0 + y - dh;
          if (anchor === 'bottom') dy = size.h - dh + y;

          dx -= dw / 2;
          dy -= dh / 2;
          ctx.drawImage(img, dx, dy, dw, dh);
        });
    }

    return {
      canvas,
      /**
       * add(key [string], { url, draw }?)
       * 或预留 add({ key, url, draw }) 的支持
       */
      async add(keyOrOpts, opts = {}) {
        let key, url, draw;

        if (typeof keyOrOpts === 'string') {
          key = keyOrOpts;
          url = urls[key]?.[index[key]];
          draw = null;
        } else {
          // 预留: add({ key, url, draw })
          key  = keyOrOpts.key;
          url  = keyOrOpts.url;
          draw = keyOrOpts.draw || null;
        }

        if (!url || url === 'undefined' || String(url).trim() === '') return;

        const img = await load(url);
        layers[key] = draw ? { img, draw } : img;
        redraw();
      },
      remove(key) {
        if (!layers[key]) return;
        layers[key] = null;
        delete layers[key];
        redraw();
      },
      async change(key) {
        const arr = urls[key] || [];
        if (!arr.length) return;
        index[key] = (index[key] + 1) % arr.length;
        const url = arr[index[key]];
        const img = await load(url);
        layers[key] = img;
        redraw();
      },
      async setImage(key, url) {
        if (!url) return;
        const img = await load(url);
        layers[key] = img;
        redraw();
      },
      urls,
      index,
    };
  }

  /***************** 创建手表实例（注意 stack 的 key 和 LAYOUT 一致） *****************/
  const watch = createWatch({
    canvas: '#wc-canvas',
    stack: {
      case: [],
      dial: [],
      hour: '',
      minute: '',
      second: '',
      strapTop: '',
      strapBottom: '',
    },
    pos: {
      case: {x:200, y:200},
      dial: {x:200, y:200},
      hour: {x:200, y:200},
      minute:  {x:200, y:200},
      second:  {x:200, y:200},
    },
  });

  /***************** GID -> URL 缓存与工具函数 *****************/
  // 全局缓存：GID -> URL
  const gidUrlCache = new Map();

  // 单个 GID 转换为 URL（带缓存）
  async function gidToURL(gid) {
    if (!gid) return '';

    if (gidUrlCache.has(gid)) {
      return gidUrlCache.get(gid);
    }

    const res = await fetch(`https://${STORE}/api/${API_VER}/graphql.json`, {
      method: 'POST',
      headers: SF_HEADERS,
      body: JSON.stringify({
        query: `
          query($id: ID!) {
            node(id: $id) {
              ... on MediaImage {
                image {
                  url(transform: { maxWidth: 800 })
                }
              }
            }
          }`,
        variables: { id: gid },
      }),
    });

    const { data, errors } = await res.json();
    if (errors) {
      console.error('gidToURL error:', errors);
      throw errors;
    }

    const url = data?.node?.image?.url || '';
    gidUrlCache.set(gid, url);
    return url;
  }

  // 多个 GID 一次转 URL（仍然会复用 gidToURL 的缓存）
  async function gidsToUrlMap(gids) {
    const uniq = [...new Set(gids.filter(Boolean))];
    if (!uniq.length) return {};

    const jobs = uniq.map(async (g) => [g, await gidToURL(g)]);
    const pairs = await Promise.all(jobs);
    return Object.fromEntries(pairs);
  }

  /***************** Metaobject 相关工具函数 *****************/
  // 单个 Metaobject
  async function getMetaobject(gid) {
    if (!gid) return null;

    const res = await fetch(`https://${STORE}/api/${API_VER}/graphql.json`, {
      method : 'POST',
      headers: SF_HEADERS,
      body: JSON.stringify({
        query: `
          query($id: ID!) {
            metaobject(id: $id) {
              id
              type
              handle
              fields { key value }
            }
          }`,
        variables: { id: gid },
      }),
    });

    const json = await res.json();
    if (json.errors) {
      console.error('getMetaobject error:', json.errors);
      throw json.errors;
    }
    return json.data?.metaobject || null;
  }

  // 批量 Metaobject（nodes(ids: ...)）
  async function getMetaobjectsBulk(gids = []) {
    const ids = [...new Set(gids.filter(Boolean))];
    if (!ids.length) return [];

    const res = await fetch(`https://${STORE}/api/${API_VER}/graphql.json`, {
      method: 'POST',
      headers: SF_HEADERS,
      body: JSON.stringify({
        query: `
          query($ids: [ID!]!) {
            nodes(ids: $ids) {
              __typename
              ... on Metaobject {
                id
                type
                handle
                fields { key value }
              }
            }
          }`,
        variables: { ids },
      }),
    });

    const json = await res.json();
    if (json.errors) {
      console.error('getMetaobjectsBulk error:', json.errors);
      throw json.errors;
    }

    const nodes = json.data?.nodes || [];
    return nodes.filter((n) => n && n.__typename === 'Metaobject');
  }

  // 扁平化：给定多个 gid -> 返回 [{id,type,handle,...fields...}]
  async function flatteningevent(gids) {
    if (!Array.isArray(gids) || !gids.length) return [];

    try {
      const metaList = await getMetaobjectsBulk(gids);
      return metaList.map((m) =>
        (m.fields || []).reduce((o, { key, value }) => {
          let parsed;
          try {
            parsed = JSON.parse(value);
          } catch {
            parsed = value;
          }
          o[key] = parsed;
          return o;
        }, { id: m.id, type: m.type, handle: m.handle }),
      );
    } catch (err) {
      console.warn('flatteningevent error:', err);
      return [];
    }
  }

  /***************** 左侧标题渲染（parent_type -> sentData 初始化） *****************/
  datas.sort((a, b) => a.oder - b.oder);

  (async () => {
    const htmlArr = await Promise.all(
      datas.map(async (item) => {
        let pid = '';
        if (item.groups?.[0]) {
          try {
            const meta = await getMetaobject(item.groups[0]);
            if (meta?.fields) {
              const parentField = meta.fields.find((f) => f.key === 'parent_type');
              pid = parentField?.value || '';
            }
          } catch (err) {
            console.warn('getMetaobject in left title failed:', err);
          }
        }

        if (pid && !sentData[pid]) {
          sentData[pid] = { type: '', text: '', vantId: '', price: 0 };
        }

        return `
          <div class="title_content">
            <div class="title_header">${item.group_name}</div>
            <div class="title_value" id="${pid}"></div>
          </div>`;
      })
    );

    document.getElementById('left-content').innerHTML = htmlArr.join('');
  })();

  /***************** 右侧三级结构容器 *****************/
  const contents = document.createElement('div'); // 一级容器
  const level2   = document.createElement('div'); // 二级容器
  const level3   = document.createElement('div'); // 三级容器

  async function renderList() {
    const box = document.getElementById('wc-root');

    contents.className = 'contents-item';
    level2.className   = 'level2-item';
    level3.className   = 'level3-item';

    box.appendChild(contents);
    box.appendChild(level2);
    box.appendChild(level3);

    for (let i = 0; i < datas.length; i++) {
      const item = datas[i];
      const wrap = document.createElement('div');
      wrap.className = 'group-item';
      wrap.dataset.index = String(i);   // 用于点击时知道是哪个一级类目
      if (item.oder != null) wrap.dataset.oder = String(item.oder);

      // 一级项有 group_image，就取图片；否则用文字
      if (item.group_image) {
        try {
          const url = await gidToURL(item.group_image);
          const img = document.createElement('img');
          img.src = url;
          img.alt = item.group_name;
          wrap.appendChild(img);
        } catch (e) {
          wrap.textContent = item.group_name;
        }
      } else {
        wrap.textContent = item.group_name;
      }

      if (item.groups?.length) {
        wrap.dataset.groups = JSON.stringify(item.groups);
      }

      contents.appendChild(wrap);

      // 表壳与其它选项一致：不再默认加载颜色列表，等用户点击一级后再加载三级类目
    }
  }
  renderList();

  /***************** buildColorHtml：颜色/第三级（带 expand_color）渲染 *****************/
  async function buildColorHtml(item) {
    if (!item.groups?.length) return '';

    // 1. 批量拉第二级 metaobject
    const level2Raw = await getMetaobjectsBulk(item.groups);
    const level2List = level2Raw.map((m) =>
      (m.fields || []).reduce((o, { key, value }) => {
        o[key] = value;
        return o;
      }, {}),
    );

    const withExpand = [];   // 有 expand_color 的二级
    const withoutExpand = []; // 没有 expand_color 的二级

    level2List.forEach((fields) => {
      const obj = { ...fields };
      if (obj.expand_color) {
        withExpand.push({
          parent_type: obj.parent_type || '',
          expand_color: obj.expand_color,
        });
      } else {
        withoutExpand.push(obj);
      }
    });

    let colorHtml = '';

    if (withExpand.length) {
      // 2. 收集所有第三级 gid 并批量拉取
      const allExpandGids = withExpand.flatMap((o) => {
        try {
          return JSON.parse(o.expand_color) || [];
        } catch {
          return [];
        }
      });

      const expandRaw = await getMetaobjectsBulk(allExpandGids);
      const expandObjs = expandRaw.map((m) =>
        (m.fields || []).reduce((o, { key, value }) => {
          o[key] = value;
          return o;
        }, {}),
      );

      // 3. 一次性解析所有图片 URL
      const imageGids = expandObjs.flatMap((o) => [
        o.color_image,
        o.color_show_image,
      ]);
      const urlMap = await gidsToUrlMap(imageGids);

      // 4. 默认先画第一张展示图
      const firstShowGid = expandObjs[0]?.color_show_image;
      const firstUrl = firstShowGid && urlMap[firstShowGid];
      if (firstUrl) {
        watch.urls.case = [firstUrl];
        watch.index.case = 0;
        watch.remove('case');
        await watch.add('case');
      }

      // 5. 拼装 HTML
      let idx = 0;
      colorHtml = withExpand
        .map((l2) => {
          let html = '';
          let gids;
          try {
            gids = JSON.parse(l2.expand_color) || [];
          } catch {
            gids = [];
          }

          gids.forEach(() => {
            const o = expandObjs[idx++] || {};
            const colorImg = o.color_image && urlMap[o.color_image];
            const showImg  = o.color_show_image && urlMap[o.color_show_image];

            const colorPrice = o.color_price || '';

            html += `
<div class="color_content">
  <div class="color_title" title="${o.color_name || ''}">
    ${o.color_name || ''}
  </div>
  <div class="color_value"
       data-attribute-name="${o.attribute_name || ''}"
       data-color_price='${typeof colorPrice === 'string' ? colorPrice : JSON.stringify(colorPrice)}'
       data-variant_id='${o.variant_id || ''}'
       data-image-url="${showImg || ''}"
       data-title-id="${l2.parent_type}">
    ${
      colorImg
        ? `<img src="${colorImg}" width="50" height="50"/>`
        : '<div class="color-placeholder"></div>'
    }
  </div>
</div>`;
          });

          return html;
        })
        .join('');
    }

    // 6. 没有 expand_color 的兜底渲染
    const fallbackHtml = await renderFallback(withoutExpand);
    return colorHtml + fallbackHtml;
  }

  // 没有 expand_color 的简单兜底
  async function renderFallback(objs) {
    if (!objs || !objs.length) return '';
    return objs
      .map((o) => `
    <div class="fallback_content">
      <span>${o.title || o.name || ''}</span>
    </div>`)
      .join('');
  }

  /***************** buildlevel2：点击一级后渲染第二级列表 *****************/
  function buildlevel2(dataArry = []) {
    if (!Array.isArray(dataArry) || dataArry.length === 0) {
      return document.createDocumentFragment();
    }

    const frag = document.createDocumentFragment();

    dataArry.forEach((item) => {
      const groupJson = JSON.stringify(item.group || []);
      const div = document.createElement('div');
      div.className = 'level2-item-content';
      div.dataset.groups = groupJson;
      div.textContent = item.group_name || '';
      frag.appendChild(div);
    });

    return frag;
  }

  /***************** buildlevel3：点击二级后渲染第三级列表 *****************/
  async function buildlevel3(dataArray = []) {
    if (!Array.isArray(dataArray) || dataArray.length === 0) {
      const empty = document.createElement('div');
      empty.className = 'level3-empty';
      empty.textContent = '暂无子分组';
      return empty;
    }

    // 1. 收集所有预览图 GID
    const previewImgGids = dataArray.map((i) => i.preview_img).filter(Boolean);
    const previewShowGids = dataArray
      .map((i) => i.preview_show_img)
      .filter(Boolean);

    const allGids = [...previewImgGids, ...previewShowGids];
    const urlMap = await gidsToUrlMap(allGids);

    // 2. 构建 DOM 片段
    const frag = document.createDocumentFragment();

    dataArray.forEach((item) => {
      const div = document.createElement('div');
      div.className = 'level3-item-content';

      if (item.preview_img) {
        const url = urlMap[item.preview_img] || '';
        if (url) {
          const img = document.createElement('img');
          img.src = url;
          img.alt = item.group_name || '';
          div.appendChild(img);
        }
      }

      div.dataset.groups       = JSON.stringify(item.group || []);
      div.dataset.option_name  = item.option_name || '';
      div.dataset.price_delta  = JSON.stringify(item.price_delta || {});
      div.dataset.parent_type  = item.parent_type || '';
      div.dataset.variant_id   = item.variant_id || '';
      if (item.preview_show_img) {
        div.dataset.preview_show_img = urlMap[item.preview_show_img] || '';
      }

      frag.appendChild(div);
    });

    return frag;
  }

  /***************** 一级（contents）点击事件：切换第二级 + 第三级 + 一级高亮 *****************/
  // 使用三级类目由主题配置 three_level_parent_types 决定；未配置则按 expand_color 自动判断
  contents.addEventListener('click', async (e) => {
    const item = e.target.closest('.group-item');
    if (!item) return;

    // 一级 active 高亮
    contents.querySelectorAll('.group-item.active')
      .forEach(el => el.classList.remove('active'));
    item.classList.add('active');

    const raw = item.dataset.groups;
    if (!raw) return;

    const dataIndex = parseInt(item.dataset.index, 10);
    const currentData = datas[dataIndex];
    const useThreeLevel = currentData && threeLevelParentTypesSet.size > 0 && threeLevelParentTypesSet.has(currentData.parent_type);

    const gids = JSON.parse(raw) || [];
    setLoading(true);
    try {
      const level2Datas = await flatteningevent(gids);
      if (!level2Datas.length) return;

      // 表壳或没有 expand_color 的类目：统一走三级类目（二级列表 + 三级选项）
      if (useThreeLevel || !level2Datas[0].expand_color) {
        const level3Datas = level2Datas[0]?.group
          ? await flatteningevent(level2Datas[0].group)
          : [];

        level2.innerHTML = '';
        level2.appendChild(buildlevel2(level2Datas));

        level3.innerHTML = '';
        level3.appendChild(await buildlevel3(level3Datas));
      } else {
        const html = await buildColorHtml(currentData);
        level2.innerHTML = '';
        level3.innerHTML = '';
        level2.innerHTML = html;
      }
    } finally {
      setLoading(false);
    }
  });

  /***************** 二级（level2）点击事件：切换第三级 + 二级下划线高亮 *****************/
  level2.addEventListener('click', async (e) => {
    const item = e.target.closest('.level2-item-content');
    if (!item) return;

    // 二级 active 高亮（文字下划线）
    level2.querySelectorAll('.level2-item-content.active')
      .forEach(el => el.classList.remove('active'));
    item.classList.add('active');

    const raw = item.dataset.groups;
    if (!raw) return;

    const gids = JSON.parse(raw) || [];
    setLoading(true);
    try {
      const level3Datas = await flatteningevent(gids);
      level3.innerHTML = '';
      level3.appendChild(await buildlevel3(level3Datas));
    } finally {
      setLoading(false);
    }
  });

  /***************** 第三级（level3）点击事件：切换对应图层 *****************/
  level3.addEventListener('click', async (e) => {
    const item = e.target.closest('.level3-item-content');
    if (!item) return;

    const newDialUrl = item.dataset.preview_show_img;
    if (!newDialUrl) return;

    setLoading(true);
    try {
      const parentType = item.dataset.parent_type || '';
      console.log(parentType,"123")
      // 如果 metaobject 里用的是 min/sec，这里映射到 minute/second
      let typeKey = parentType;
      if (typeKey === 'min')  typeKey = 'minute';
      if (typeKey === 'sec')  typeKey = 'second';

      if (typeKey.startsWith('glass')) {
        await watch.setImage('strapTop', newDialUrl);
        await watch.setImage('strapBottom', newDialUrl);
      } else {
        await watch.setImage(typeKey, newDialUrl);
      }

      renderTypeText(item);
    } finally {
      setLoading(false);
    }
  });

  /***************** 颜色项（.color_value）点击事件：更新文字 + 价格 + 图像 *****************/
  document.addEventListener('click', async function (e) {
    const box = e.target.closest('.color_value');
    if (!box) return;

    const titleId   = box.dataset.titleId;
    const attrName  = box.dataset.attributeName;
    const variantId = box.dataset.variant_id || '';
    const imgUrl    = box.dataset.imageUrl;

    let price_delta = {};
    try {
      price_delta = box.dataset.color_price
        ? JSON.parse(box.dataset.color_price)
        : {};
    } catch {
      price_delta = {};
    }

    if (titleId) {
      const target = document.getElementById(titleId);
      if (target) target.textContent = attrName;

      if (!sentData[titleId]) {
        sentData[titleId] = { type: '', text: '', vantId: '', price: 0 };
      }

      sentData[titleId].type  = titleId;
      sentData[titleId].text  = attrName;
      sentData[titleId].price =
        price_delta.amount != null ? Number(price_delta.amount) * 100 : 0;
      sentData[titleId].vantId = variantId || null;
    }

    // 更新总价
    updatePrice(sentData);

    // 更新图像（表壳）
    if (imgUrl) {
      setLoading(true);
      try {
        watch.urls.case = [imgUrl];
        watch.index.case = 0;
        watch.remove('case');
        await watch.add('case');
      } finally {
        setLoading(false);
      }
    }
  });

  /***************** 公共：渲染型号文字 + 更新 sentData *****************/
  function renderTypeText(item) {
    if (!item) return;
    const titleId  = item.dataset.parent_type;
    const attrName = item.dataset.option_name;

    let price_delta = {};
    try {
      price_delta = item.dataset.price_delta
        ? JSON.parse(item.dataset.price_delta)
        : {};
    } catch {
      price_delta = {};
    }

    if (titleId) {
      const target = document.getElementById(titleId);
      if (target) target.textContent = attrName;
    }

    if (!sentData[titleId]) {
      sentData[titleId] = { type: '', text: '', vantId: '', price: 0 };
    }

    sentData[titleId].type  = titleId;
    sentData[titleId].text  = attrName;
    sentData[titleId].price =
      price_delta.amount != null ? Number(price_delta.amount) * 100 : 0;
    sentData[titleId].vantId = item.dataset.variant_id || null;

    updatePrice(sentData);
  }

  /***************** 价格累加：分 -> 元 *****************/
  function sumPriceToYuan(data) {
    let total = 0;

    function walk(obj) {
      if (Array.isArray(obj)) {
        obj.forEach(walk);
      } else if (obj !== null && typeof obj === 'object') {
        Object.keys(obj).forEach((k) => {
          if (k === 'price') {
            const v = obj[k];
            total += Number(v) || 0;
          } else {
            walk(obj[k]);
          }
        });
      }
    }

    walk(data);
    return (total / 100).toFixed(2);
  }

  function updatePrice(obj) {
    const newPrice = sumPriceToYuan(obj);
    const tp = document.getElementById('totalPrice');
    if (tp) {
      tp.textContent = newPrice;
    }
  }

  /***************** 加入购物车逻辑（/cart/add.js） *****************/
  // 必选校验：OPTIONAL_PART_KEYS 来自主题配置 data-optional-part-types，不校验、未选不提交
  function addToCart() {
    const missing = []; // 未选或 variant 为空的必选项
    for (const key in sentData) {
      if (OPTIONAL_PART_KEYS.includes(key)) continue;
      const v = sentData[key].vantId;
      if (v === null || v === '' || v === undefined) {
        missing.push(key);
      }
    }
    if (missing.length > 0) {
      console.warn('[watch-customizer] 以下必选项未选择或未配置 variant_id：', missing, '当前 sentData：', JSON.parse(JSON.stringify(sentData)));
      alert('Please choose to customize all. Missing or invalid: ' + missing.join(', ') + '. Check that each option has variant_id in metaobject.');
      return;
    }

    // 组装加入购物车的 items：1 条主商品 + 多条配件
    const items = [];

    // 1）主商品：必须有合法的 mainVariantId
    const normalizedMainId = normalizeVariantId(mainVariantId);
    if (!normalizedMainId) {
      alert('主商品变体 ID 未配置，请在 section 设置中填写 main_variant_id。');
      return;
    }

    // 主商品 line item：可以把整套配置打在 properties 里，方便在后台查看
    items.push({
      id: normalizedMainId,
      quantity: 1,
      properties: {
        _watch_config: JSON.stringify(
          Object.fromEntries(
            Object.entries(sentData).map(([k, v]) => [k, v.text])
          )
        ),
      },
    });

    // 2）配件：每个已选中的配件作为一个附加商品
    const accessoryItems = Object.values(sentData)
      .filter((item) => item.vantId != null && item.vantId !== '')
      .map((item) => {
        const accId = normalizeVariantId(item.vantId);
        // 如果某个部件的 variant_id 恰好等于主商品变体 ID，说明它本身就是主商品，
        // 不应该再作为一个额外 line item 加一次，否则会出现“主商品添加两次”的情况。
        if (!accId || accId === normalizedMainId) return null;
        return accId
          ? {
              id: accId,
              quantity: 1,
              properties: {
                _parent_main_variant: normalizedMainId,
                [item.type]: item.text,
              },
            }
          : null;
      })
      .filter(Boolean);

    items.push(...accessoryItems);

    console.debug('[watch-customizer] cart items to add', items);

    setLoading(true);
    // 与产品页保持一致：请求 /cart/add.js 时带上 sections=cart-notification，
    // 这样接口会返回 cart-notification 区块 HTML，方便我们在这里手动触发弹窗。
    fetch('/cart/add.js?sections=cart-notification', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),  // 必须包在 { items: [...] }
    })
      .then(async (r) => {
        if (!r.ok) {
          const text = await r.text();
          throw new Error(text || 'Failed to add to cart');
        }
        return r.json();
      })
      .then((data) => {
        // 1）更新头部购物车数量
        const p = refreshMiniCart();
        // 2）如果主题有 cart-notification 区块，则尝试更新并弹出
        tryShowCartNotification(data);
        return p;
      })
      .catch((err) => {
        console.error('addToCart error:', err);
        alert('Add to cart failed: ' + err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  // 根据 /cart/add.js?sections=cart-notification 的返回数据，
  // 尝试更新并展示主题里的 cart-notification 弹窗（与产品页行为对齐）
  function tryShowCartNotification(data) {
    if (!data || !data.sections) return;

    // sections 对象的 key 通常是 "cart-notification"
    const sectionHtml =
      data.sections['cart-notification'] ||
      data.sections['cart-notification-drawer'] ||
      '';
    if (!sectionHtml) return;

    const existing = document.querySelector('#cart-notification');
    if (!existing) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, 'text/html');
    const newNode =
      doc.querySelector('#cart-notification') || doc.body.firstElementChild;
    if (!newNode) return;

    // 用接口返回的最新内容替换当前弹窗内部结构
    existing.innerHTML = newNode.innerHTML;

    // 大部分主题会通过添加 active / is-open 类来显示弹窗，先尝试这样处理
    existing.classList.add('active', 'is-open');

    // 如果主题在 window 上挂了一个 cartNotification 实例，也尝试调用它的 open 方法
    if (window.cartNotification && typeof window.cartNotification.open === 'function') {
      try {
        window.cartNotification.open();
      } catch (e) {
        console.warn('cartNotification.open 调用失败：', e);
      }
    }
  }

  async function refreshMiniCart() {
    try {
      // 使用 Sections API 拉取 cart-icon-bubble 区块，服务端会按“可见件数”（排除 addon-hidden）渲染，与购物车列表一致
      const cartUrl = typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.cart_url
        ? window.Shopify.routes.cart_url
        : '/cart';
      const res = await fetch(`${cartUrl}?sections=cart-icon-bubble`);
      if (!res.ok) return;
      const data = await res.json();
      const sectionHtml = data.sections && data.sections['cart-icon-bubble'];
      if (!sectionHtml) return;

      const headerCart = document.querySelector('#cart-icon-bubble');
      if (!headerCart) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      const sectionRoot = doc.body.firstElementChild;
      if (sectionRoot) {
        headerCart.innerHTML = sectionRoot.innerHTML;
      }
    } catch (e) {
      console.warn('refreshMiniCart error:', e);
    }
  }

  // 暴露给外部按钮调用
  window.addToCart = addToCart;
})();